import { UserService } from './core/user.service';
import { MenuItemModel } from './shared/models/menu-item.model';
import { UrlConfigContainer } from './core/url-config';
import { AjaxDataServiceService } from './core/ajax-data-service.service';
import { Component, OnInit } from '@angular/core';
import { LoadIndicatorService } from './core/load-indicator.service';
import { CustomMessageService } from './core/message.service';
import { UrlConfigService } from '@hrra/core';
import { AuthService } from './core/auth.service';
import { map, of, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    this.authService.init();

  }

  title = 'app works!';

  //public menuItems: MenuItemModel[];

  public get messages() {
    return this.messageService.messages();
  }

  constructor(
    private messageService: CustomMessageService,
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>,
    private authService: AuthService
  ) { }
}
